import {Constant} from './Constant';
import {Role} from '../../user/model/Role';
import {Authority} from '../../user/model/Authority';
import {Enterprise} from '../../user/model/Enterprise';
import {Partner} from '../../user/model/Partner';
import {Workflowtype} from '../../user/model/Workflowtype';
import {Job} from '../../user/model/Job';
import {Workflow} from '../../user/model/Workflow';
import {Shoppingcard} from '../../user/model/Shoppingcard';
import {Service} from '../../user/model/Service';
import {Module} from '../../user/model/Module';
import {Operation} from '../../user/model/Operation';
import {Signatureapptype} from '../../user/model/Signatureapptype';
import {Typefile} from '../../user/model/Typefile';
import {Operatingsystem} from '../../user/model/Operatingsystem';
import {Tsaprovider} from '../../user/model/Tsaprovider';
import {SearchDocument} from '../../user/model/search/SearchDocument';
import {ParticipantType} from './enum/ParticipantType';
import {Identificationdocument} from '../../user/model/Identificationdocument';
import {Dialog} from './Dialog';
import {InformType} from './enum/InformType';
import {Pagestamp} from '../../user/model/Pagestamp';
import {Fonttype} from '../../user/model/Fonttype';
import {Fontsize} from '../../user/model/Fontsize';
import {Uanatacasignaturelevel} from '../../user/model/Uanatacasignaturelevel';
import {State} from '../../user/model/State';
import {Label} from '../../user/model/Label';
import {Datetype} from '../../user/model/Datetype';
import {Managementtype} from '../../user/model/Managementtype';

export class LocalStorage {

  public static getEnterprisesExtraBy(partnerId: number): Enterprise[] {
    const unique: Enterprise[] = [{
      id: 0,
      name: 'TODOS',
      tradeName: 'TODOS',
      isPartner: false,
      isCustomer: false,
    }];
    return unique.concat(this.getEnterprisesBy(partnerId));
  }

  public static getEnterprisesExtra(): Enterprise[] {
    const unique: Enterprise[] = [{
      id: 0,
      name: 'TODOS',
      tradeName: 'TODOS',
      isPartner: false,
      isCustomer: false,
    }];
    return unique.concat(this.getEnterprises());
  }

  public static getEnterprisesBy(partnerId: number): Enterprise[] {
    if (partnerId === Constant.ALL_PARTNER_ID) {
      return [];
    }
    return this.getEnterprises().filter(value => partnerId === value.partnerId);
  }

  public static getEnterprises(): Enterprise[] {
    const enterprises = localStorage.getItem('enterprises');
    if (enterprises) {
      const parsed = JSON.parse(enterprises);
      return Array.isArray(parsed) ? parsed : [];
    }
    return [];
  }

  public static getOperations(): Operation[] {
    const operations = localStorage.getItem('operations');
    if (operations) {
      return JSON.parse(operations);
    }
  }

  public static getPartners(): Partner[] {
    const partners = localStorage.getItem('partners');
    if (partners) {
      const parsed = JSON.parse(partners);
      return Array.isArray(parsed) ? parsed : [];
    }
    return [];
  }

  public static getWorkflows(): Workflow[] {
    const workflows = localStorage.getItem('workflows');
    if (workflows) {
      const parsed = JSON.parse(workflows);
      return Array.isArray(parsed) ? parsed : [];
    }
    return [];
  }

  public static getWorkflowsExtraBy(enterpriseId: number): Workflow[] {
    const unique: Workflow[] = [{
      id: 0,
      description: 'TODOS'
    }];
    return unique.concat(this.getWorkflowsBy(enterpriseId));
  }

  public static getListValueReniec(): string {
    const list = ['checkDigit', 'lastName', 'lastName2', 'name', 'issueDate',
      'civilStatus', 'gender', 'birthDate', 'fatherName', 'motherName'];
    // tslint:disable-next-line:no-bitwise
    return list[(Math.random() * list.length) | 0];
  }

  public static getWorkflowsBy(enterpriseId: number): Workflow[] {
    if (enterpriseId === Constant.ALL_ENTERPRISE_ID) {
      return [];
    }
    return this.getWorkflows()
      .filter(workflow => (workflow.enterpriseId === enterpriseId) && workflow.ready2Use === Constant.READY_TO_USE);
  }

  public static getProfile(): any {
    const profile = localStorage.getItem('profile');
    if (profile) {
      return JSON.parse(profile);
    }
    return {};
  }

  public static getEnterpriseId(): number {
    return this.getProfile().enterpriseId;
  }

  /**
   * Indica si un usuario ha realizado alguna notificación(NOTCER)
   */
  public static shippingNotification(): boolean {
    return this.getProfile().shippingNotification;
  }

  public static getEnterpriseIdView() {
    return this.getProfile().enterpriseIdView;
  }

  public static getPersonId() {
    return this.getProfile().personId;
  }

  static getIdentificationdocuments(): Identificationdocument[] {
    const identificationdocuments = localStorage.getItem('identificationdocuments');
    if (identificationdocuments) {
      return JSON.parse(identificationdocuments);
    }
  }

  public static getRolesExtra(): Role[] {
    const unique: Role[] = [{
      id: 0,
      nameView: 'TODOS',
      abbreviation: 'TODOS'
    }];
    return unique.concat(this.getRoles());
  }

  public static getRoles(): Role[] {
    const roles = localStorage.getItem('roles');
    if (roles) {
      return JSON.parse(roles);
    }
    return [];
  }

  /**
   * Obtiene la posiciones de la rúbrica  de cada recurso. Estas posiciones son almacenadas en el localStorage
   * al cargarse la pagina de firma.
   */
  public static getPositionRubrics(): any[] {
    const positionRubrics = localStorage.getItem('positionRubrics');
    if (positionRubrics) {
      return JSON.parse(positionRubrics);
    }
    return [];
  }

  /**
   * Obtiene las descripciones de firma. Estas posiciones son almacenadas en el localStorage desde el front
   * al cargarse la pagina de firma.
   */
  public static getSignatureDescriptions(): any[] {
    const signatureDescriptions = localStorage.getItem('signatureDescriptions');
    if (signatureDescriptions) {
      return JSON.parse(signatureDescriptions);
    }
    return null;
  }

  /**
   * Obtiene las descripciones de firma seleccionados. Estas posiciones son almacenadas en el localStorage
   * al cargarse la pagina de firma.
   */
  public static getSelectedSignatureDescriptions(): any[] {
    const signatureDescriptions = localStorage.getItem('selectedSignatureDescriptions');
    if (signatureDescriptions) {
      return JSON.parse(signatureDescriptions);
    }
    return null;
  }

  /**
   * Obtiene la nueva imagen agregada por el usuario
   */
  public static getRubricrubricFile(): any {
    const signatureDescriptions = localStorage.getItem('rubricFile');
    if (signatureDescriptions) {
      return JSON.parse(signatureDescriptions);
    }
    return null;
  }

  /**
   * Obtiene la fecha y hora a notificar
   */
  public static getDate2Notify(): any[] {
    const date2notofy = localStorage.getItem('date2notify');
    if (date2notofy) {
      return JSON.parse(date2notofy);
    }
    return null;
  }

  public static getUserRoles(): Role[] {
    const roles = this.getProfile().roles;
    if (roles) {
      return roles;
    }
    return [];
  }

  public static getUserAuthorities(): Authority[] {
    return this.getProfile().authorities;
  }

  public static getParticipantTypesExtra(): any {
    const unique: any[] = [{
      id: 0,
      description: 'TODOS'
    }];
    return unique.concat(this.getParticipantTypes());
  }

  public static getParticipantTypes(): any {
    const participanttypes = localStorage.getItem('participanttypes');
    if (participanttypes) {
      return JSON.parse(participanttypes);
    }
  }

  public static getPersonTypes(): any {
    const persontypes = localStorage.getItem('persontypes');
    if (persontypes) {
      return JSON.parse(persontypes);
    }
  }

  public static getJobs(): Job[] {
    const jobs = localStorage.getItem('jobs');
    if (jobs) {
      return JSON.parse(jobs);
    }
  }

  public static getCountries(): any {
    const countries = localStorage.getItem('countries');
    if (countries) {
      return JSON.parse(countries);
    }
  }

  public static getJobsBy(enterpriseId: number): Job[] {
    const jobs: Job[] = this.getJobs();
    return jobs.filter(job => job.enterpriseId === enterpriseId);
  }

  public static getEnterpriseDocumentNumber(): string {
    return this.getProfile().enterpriseDocumentNumber;
  }

  public static getEnterpriseName(): string {
    return this.getProfile().enterpriseName;
  }

  public static getEnterpriseDocumentNumberView() {
    return this.getProfile().enterpriseDocumentNumberView;
  }

  public static getEnterpriseNameView() {
    return this.getProfile().enterpriseNameView;
  }

  public static getParticipantType() {
    return this.getProfile().participantType;
  }

  public static getWorkflowsByPerson(): Workflow[] {
    const workflows: Workflow[] = this.getProfile().workflows;
    return workflows.filter(workflow => workflow.ready2Use === Constant.READY_TO_USE);
  }

  public static getWorkflowsExtraByPerson(): Workflow[] {
    const unique: Workflow[] = [{
      id: 0,
      description: 'TODOS',
    }];
    return unique.concat(this.getWorkflowsByPerson());
  }

  public static getTodayString(): string {
    const today = localStorage.getItem('today');
    if (today) {
      return JSON.parse(today);
    }
  }

  public static getFontsizes(): Fontsize[] {
    const fontsizes = localStorage.getItem('fontsizes');
    if (fontsizes) {
      return JSON.parse(fontsizes);
    }
  }

  public static getFonttypes(): Fonttype[] {
    const fonttypes = localStorage.getItem('fonttypes');
    if (fonttypes) {
      return JSON.parse(fonttypes);
    }
  }

  public static getPagesstamps(): Pagestamp [] {
    const pagestamps = localStorage.getItem('pagestamps');
    if (pagestamps) {
      return JSON.parse(pagestamps);
    }
  }

  public static getContentpositions(): any {
    const contentpositions = localStorage.getItem('contentpositions');
    if (contentpositions) {
      return JSON.parse(contentpositions);
    }
  }

  public static getAuthorities(): Authority[] {
    const authorities = localStorage.getItem('authorities');
    if (authorities) {
      return JSON.parse(authorities);
    } else {
      return [];
    }
  }

  public static getModulesExtra(): Module[] {
    const unique: Module[] = [{
      id: 0,
      description: 'TODOS',
      active: 1,
    }];
    return unique.concat(this.getModules());
  }

  public static getModules(): Module[] {
    const modules = localStorage.getItem('modules');
    if (modules) {
      return JSON.parse(modules);
    }
  }

  public static getSignatureapptypeExtra(): Signatureapptype[] {
    const unique: Signatureapptype[] = [{
      id: 0,
      shortdescription: 'TODOS',
      ordersignatureapptype: 0,
      active: 1
    }];
    return unique.concat(this.getSignatureapptype());
  }

  public static getSignatureapptype(): any {
    const signatureapptypes = localStorage.getItem('signatureapptypes');
    if (signatureapptypes) {
      return JSON.parse(signatureapptypes);
    }
  }

  public static getTsaproviderExtra(): Tsaprovider[] {
    const unique: Tsaprovider[] = [{
      id: 0,
      description: 'TODOS'
    }];
    return unique.concat(this.getTsaprovider());
  }

  public static getTsaprovider(): Tsaprovider[] {
    const tsaproviders = localStorage.getItem('tsaproviders');
    if (tsaproviders) {
      return JSON.parse(tsaproviders);
    }
  }

  public static getTypefileExtra(): Typefile[] {
    const unique: Typefile[] = [{
      id: 0,
      description: 'TODOS'
    }];
    return unique.concat(this.getTypefile());
  }

  public static getTypefile(): any {
    const typefiles = localStorage.getItem('typefiles');
    if (typefiles) {
      return JSON.parse(typefiles);
    }
  }

  public static getOperatingsystemExtra(): Operatingsystem[] {
    const unique: Operatingsystem[] = [{
      id: 0,
      description: 'TODOS'
    }];
    return unique.concat(this.getOperatingsystem());
  }

  public static getOperatingsystem(): Operatingsystem[] {
    const operatingsystems = localStorage.getItem('operatingsystems');
    if (operatingsystems) {
      return JSON.parse(operatingsystems);
    }
  }

  /**
   * Obtiene la lista de los niveles de firma que se pueden usar en firma remota (Signbox)
   */
  public static getSignaturelevels(): Uanatacasignaturelevel[] {
    const uanatacasignaturelevels = localStorage.getItem('uanatacasignaturelevels');
    if (uanatacasignaturelevels) {
      return JSON.parse(uanatacasignaturelevels);
    }
  }

  public static hasDeliverOption(): boolean {
    const setting = localStorage.getItem('setting');
    if (setting) {
      return Constant.HAS_DELIVER_OPTION === JSON.parse(setting).hasDeliverOption;
    }
    return false;
  }

  public static getStates(): State[] {
    const states = localStorage.getItem('states');
    if (states) {
      return JSON.parse(states);
    }
  }

  public static getWorkflowtypes(): Workflowtype[] {
    const workflowtypes = localStorage.getItem('workflowtypes');
    if (workflowtypes) {
      return JSON.parse(workflowtypes);
    }
  }

  public static getPartnerId() {
    return this.getProfile().partnerId;
  }

  public static getUUID() {
    const uuid = localStorage.getItem('uuid');
    if (uuid) {
      return uuid;
    }
  }

  public static getHash1() {
    const hash1 = localStorage.getItem('hash1');
    if (hash1) {
      return hash1;
    }
  }

  public static getHash2() {
    const hash2 = localStorage.getItem('hash2');
    if (hash2) {
      return hash2;
    }
  }

  public static getOtherParams(): any {
    const others = localStorage.getItem('others');
    if (others) {
      return JSON.parse(others);
    }
  }

  public static hasConfigBalance(): boolean {
    const hasConfigBalance = localStorage.getItem('hasConfigBalance');
    if (hasConfigBalance) {
      return Constant.HAS_CONFIG_BALANCE === JSON.parse(hasConfigBalance);
    }
    return false;
  }

  /**
   * Obtiene valor para saber si la empresa del usuario tiene activo el demo de NOTCER
   */
  public static hasDemoNotcer(): boolean {
    const hasDemoNotcer = localStorage.getItem('hasDemoNotcer');
    if (hasDemoNotcer) {
      return Constant.HAS_CONFIG_DEMO_NOTCER === JSON.parse(hasDemoNotcer);
    }
    return false;
  }

  public static actualBalance(): number {
    const balance = localStorage.getItem('balance');
    if (balance) {
      return JSON.parse(balance);
    }
  }

  public static getShoppingcards(): Shoppingcard[] {
    const shoppingcards = localStorage.getItem('shoppingcards');
    if (shoppingcards) {
      return JSON.parse(shoppingcards);
    }
  }

  public static getServices(): Service[] {
    const services = localStorage.getItem('services');
    if (services) {
      return JSON.parse(services);
    }
  }

  // TODO
  public static getUrlAbout(): string {
    // tslint:disable-next-line:variable-name
    const _allyconfiguration = localStorage.getItem('_allyconfiguration');
    const iofeAbout = 'https://iofesac.com';
    if (_allyconfiguration) {
      const urlAbout = JSON.parse(_allyconfiguration).urlAbout;
      return urlAbout ? urlAbout : iofeAbout;
    } else {
      return iofeAbout;
    }
  }

  public static getAllyName(): string {
    // tslint:disable-next-line:variable-name
    const _allyconfiguration = localStorage.getItem('_allyconfiguration');
    const iofeName = 'IOFE S.A.C.';
    if (_allyconfiguration) {
      const allyName = JSON.parse(_allyconfiguration).allyName;
      return allyName ? allyName : iofeName;
    } else {
      return iofeName;
    }
  }

  public static getUrlLogo(): string {
    // tslint:disable-next-line:variable-name
    const _allyconfiguration = localStorage.getItem('_allyconfiguration');
    const iofeLogo = 'https://iofesac.com/wp-content/uploads/2020/10/logo-IOFESAC.png';
    if (_allyconfiguration) {
      const urlLogo = JSON.parse(_allyconfiguration).urlLogo;
      return urlLogo ? urlLogo : iofeLogo;
    } else {
      return iofeLogo;
    }
  }

  public static getBase64Logo(): string {
    let base64LogoFile;
    const token = localStorage.getItem('token');
    if (token && LocalStorage.getProfile().base64LogoFile) {
      base64LogoFile = LocalStorage.getProfile().base64LogoFile;
      if (base64LogoFile) {
        return 'data:image/jpeg;base64,' + base64LogoFile;
      } else {
        return 'data:image/jpeg;base64,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';
      }
    } else {
      return 'NOLOGO';
    }
  }

  public static setupLogo(): boolean {
    return this.getBase64Logo() !== undefined || this.publicLogoBase64() !== undefined;
  }

  public static showBalanceInfo(): boolean {
    return true;
  }

  /**
   * Actualiza los datos que necesita e utiliza del localStorage con los nuevos datos despues de realizar un cambio.
   */
  public static updateEmbeddedValuesBy(objByUpdate: any, arrayName: string, option: number) {
    const val = JSON.parse(localStorage.getItem(arrayName));
    if (val) {
      switch (option) {
        case Constant.ADD:
          val.push(objByUpdate);
          break;
        case Constant.EDIT:
          const index = val.findIndex(obj => obj.id === objByUpdate.id);
          val[index] = objByUpdate;
          break;
        case Constant.DELETE:
          const objIndex = val.findIndex(obj => obj.id === objByUpdate.id);
          if (objIndex > -1) {
            val.splice(objIndex, 1);
          }
          break;
      }
      localStorage.setItem(arrayName, JSON.stringify(val));
    }
  }

  public static getPartnersExtra(): Partner[] {
    const unique: Partner[] = [{
      id: 0,
      name: 'TODOS',
      active: 1,
    }];
    return unique.concat(this.getPartners());
  }

  public static searchDocument(): SearchDocument {
    // tslint:disable-next-line:variable-name
    const _searchDocument = localStorage.getItem('_searchDocument');
    if (_searchDocument) {
      return JSON.parse(_searchDocument);
    }
  }

  public static setItem(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public static removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public static removeItems(keys: string[]): void {
    keys.forEach(this.removeItem);
  }

  public static getItem(key: string): string | null {
    const item = localStorage.getItem(key);
    return JSON.parse(item);
  }

  public static isInvitedAuthenticated(): boolean {
    return this.getUserType() === ParticipantType.Invited;
  }

  public static getUserType(): number {
    const userType = localStorage.getItem('userType');
    if (userType) {
      return +JSON.parse(userType);
    }
  }

  /**
   * Extrae el número del documento de identificación almacenada en el localstorage
   */
  public static getUserDocumentNumber(): string {
    const userDocumentNumber = JSON.parse(localStorage.getItem('userDocumentNumber'));
    if (userDocumentNumber) {
      return userDocumentNumber.split('_')[1];
    }
  }

  /**
   * Extrae el código del documento de identificación almacenada en el localstorage
   */
  public static getIdentificationDocumentCode(): string {
    const userDocumentNumber = JSON.parse(localStorage.getItem('userDocumentNumber'));
    if (userDocumentNumber) {
      return userDocumentNumber.split('_')[0];
    }
  }

  public static getIdentificationdocument(preffix: string): Identificationdocument {
    let code;
    if (preffix === '01') {
      code = 'DNI';
    } else if (preffix === '04') {
      code = 'CE';
    } else if (preffix === '07') {
      code = 'PAS';
    } else {
      Dialog.show(InformType.Warning, 'Documento de identificación', '');
      return;
    }
    return LocalStorage.getIdentificationdocuments().find(value => value.code === code);
  }

  /**
   * Establece en el localstorage los valores que la respuesta API embedded retorne
   */
  public static setUpEmbeddedInfo(embedded: any): void {
    this.setUpOfEmbedded('today', embedded);
    this.setUpOfEmbedded('balance', embedded);
    this.setUpOfEmbedded('hasConfigBalance', embedded);
    this.setUpOfEmbedded('hasDemoNotcer', embedded);
    this.setUpOfEmbedded('setting', embedded);
    this.setUpOfEmbedded('profile', embedded);
    this.setUpOfEmbedded('workflows', embedded);
    this.setUpOfEmbedded('states', embedded);
    this.setUpOfEmbedded('workflowtypes', embedded);
    this.setUpOfEmbedded('others', embedded);
    this.setUpOfEmbedded('roles', embedded);
    this.setUpOfEmbedded('jobs', embedded);
    this.setUpOfEmbedded('countries', embedded);
    this.setUpOfEmbedded('operations', embedded);
    this.setUpOfEmbedded('enterprises', embedded);
    this.setUpOfEmbedded('authorities', embedded);
    this.setUpOfEmbedded('identificationdocuments', embedded);
    this.setUpOfEmbedded('participanttypes', embedded);
    this.setUpOfEmbedded('persontypes', embedded);
    this.setUpOfEmbedded('fontsizes', embedded);
    this.setUpOfEmbedded('fonttypes', embedded);
    this.setUpOfEmbedded('pagestamps', embedded);
    this.setUpOfEmbedded('contentpositions', embedded);
    this.setUpOfEmbedded('partners', embedded);
    this.setUpOfEmbedded('shoppingcards', embedded);
    this.setUpOfEmbedded('services', embedded);
    this.setUpOfEmbedded('labels', embedded);
    this.setUpOfEmbedded('modules', embedded);
    this.setUpOfEmbedded('tsaproviders', embedded);
    this.setUpOfEmbedded('operatingsystems', embedded);
    this.setUpOfEmbedded('signatureapptypes', embedded);
    this.setUpOfEmbedded('typefiles', embedded);
    this.setUpOfEmbedded('uanatacasignaturelevels', embedded);
    this.setUpOfEmbedded('datetypes', embedded);
    this.setUpOfEmbedded('managementtypes', embedded);
    this.setUpOfEmbedded('parameters', embedded);
    this.setUpOfEmbedded('storageunittypes', embedded);
  }

  /**
   * Establece en el localstorage el valor.
   */
  public static setUpData<T>(key: string, value: T[]): void {
    if (value?.length) {
      LocalStorage.setItem(key, value);
    }
  }

  /**
   * Extrae el valor definido por el 'key' para establecerlo en el localstorage
   *
   */
  public static setUpOfEmbedded(key: string, embedded: any): void {
    const value = embedded._embedded[key];
    if (value) {
      LocalStorage.setItem(key, value);
    }
  }

  public static updateAuthorities(authority, action: number): void {
    const authorities: Authority[] = LocalStorage.getAuthorities();
    if (action === Constant.ADD || action === Constant.EDIT) {
      authorities.forEach(authority1 => {
        if (authority.id === authority1.id) {
          const index = authorities.findIndex(value => value.id === authority.id);
          authorities.splice(index, 1);
          return;
        }
      });
      authorities.push(authority);
    } else if (action === Constant.DELETE) {
      authorities.forEach(a => {
        if (a.id === authority.id) {
          const index = authorities.findIndex(value => value.id === authority.id);
          authorities.splice(index, 1);
          return;
        }
      });
    }
    LocalStorage.setItem('authorities', authorities);
  }


  public static getLabels(): Label[] {
    const workflowtypes = localStorage.getItem('labels');
    if (workflowtypes) {
      return JSON.parse(workflowtypes);
    }
    return [];
  }

  public static getHeaderParameters(): any {
    const headerParameters = localStorage.getItem('headerParameters');
    if (headerParameters) {
      return JSON.parse(headerParameters);
    }
  }

  public static getSelectedControls(): any {
    const selectedControls = localStorage.getItem('selectedControls');
    if (selectedControls) {
      return JSON.parse(selectedControls);
    }
  }

  static getDatetypes(): Datetype[] {
    const datetypes = localStorage.getItem('datetypes');
    if (datetypes) {
      return JSON.parse(datetypes);
    }
    return [];
  }

  static getManagementtypes(): Managementtype[] {
    const managementtypes = localStorage.getItem('managementtypes');
    if (managementtypes) {
      return JSON.parse(managementtypes);
    }
    return [];
  }

  static getLimitStorage() {
    const parameterId = 10004;
    const parameters = localStorage.getItem('parameters');
    if (parameters) {
      return JSON.parse(parameters).find(parameter => parameter.id === parameterId).value;
    }
    return 0;
  }

  static getStorageTypes() {
    const storageUnitTypes = localStorage.getItem('storageunittypes');
    if (storageUnitTypes) {
      return JSON.parse(storageUnitTypes);
    }
    return [];
  }

  static getFileBase64() {
    const fileSelected = sessionStorage.getItem('base64Pdf');
    if (fileSelected) {
      return JSON.parse(fileSelected);
    } else {
      return null;
    }
  }

  static getAdsType() {
    return [{id: 1, name: 'Imagen'}, {id: 2, name: 'Texto'}];
  }

  static getDontShowAds(): boolean {
    return Boolean(localStorage.getItem('dontshowads'));
  }

  static getLastAds() {
    return localStorage.getItem('lastads');
  }

  static setLastAds(ads: any) {
    localStorage.setItem('lastads', JSON.stringify(ads));
  }

  static setDontShowAds() {
    localStorage.setItem('dontshowads', 'true');
  }

  static removeDontShowAds() {
    return localStorage.removeItem('dontshowads');
  }

  static publicLogoBase64() {
    return localStorage.getItem('enterpriseLogoBase64');
  }

  static extensionLogoBase64() {
    return localStorage.getItem('logoFileExtension');
  }

  /*Guardamos en local storage el tiempo*/
  static setSessionDuration(value: number) {
    localStorage.setItem('sessionDuration', String(value));
  }

  /*Guardamos en local storage el nuevo tiempo recalculado*/
  static getLastSessionDuration() {
    return localStorage.getItem('sessionDuration');
  }

  /*limpiamos local storage*/
  static removeSessionDuration() {
    localStorage.removeItem('sessionDuration');
  }

  static getImageCompress(imageCompress: string, name: string) {
    return localStorage.getItem(name) ? JSON.parse(localStorage.getItem(name)) : imageCompress;
  }

  static getIpAddress() {
    return localStorage.getItem('ip_address');
  }

  static getDateDownLeft() {
    const date = JSON.parse(localStorage.getItem('dateDown'));
    if (date) {
      return date;
    }
    return '0';
  }

  public static getDefaultEnterprise() {
    return [{
      id: 0,
      name: 'TODOS',
      tradeName: 'TODOS',
      isPartner: false,
      isCustomer: false,
    }];
  }

  public static addEnterprise(enterprises: Enterprise[]) {
    return [{
      id: 0,
      name: 'TODOS',
      tradeName: 'TODOS',
      isPartner: false,
      isCustomer: false,
    }, ...enterprises];
  }

  public static getDefaultWorkflows(): Workflow[] {
    return [{
      id: 0,
      description: 'TODOS',
    }];
  }
}
